import { ListenerDictionary } from '../components/video-player/video-player.events'
import { HeartbeatService } from '../services/heartbeat.service'
import { Subject } from 'rxjs'
import { AuthenticatedStreamResponse } from '@flocasts/flosports30-types/dist/live-api'
import { VideoPlayerScreenErrorCode } from '../../shared/video-player/models/video-player-screen-error-code.model'
import { HttpErrorResponse } from '@angular/common/http'

interface SubjectDictionary {
  [key: string]: Subject<void>
}

interface HeartBeatErrorWrapper {
  error: {
    error: HeartBeatError
  }
}

interface HeartBeatError {
  message: string
  statusCode: number
}

const mapServiceErrorsToVideoErrors = (serviceErrorCode: number) => {
  switch (serviceErrorCode) {
    case 400:
      return VideoPlayerScreenErrorCode.STREAM_NOT_FOUND
    case 401:
      return VideoPlayerScreenErrorCode.AUTHENTICATION_REQUIRED
    case 402:
      return VideoPlayerScreenErrorCode.UNAUTHORIZED
    case 403:
      return VideoPlayerScreenErrorCode.FORBIDDEN
    case 404:
      return VideoPlayerScreenErrorCode.UNKNOWN_ERROR
    case 409:
      return VideoPlayerScreenErrorCode.REVOKED_SHARED_OR_MAX_CLIENT
    case 411:
      return VideoPlayerScreenErrorCode.REVOKED_BANNED_USER
    case 422:
      return VideoPlayerScreenErrorCode.STREAM_COMPLETED
    default:
      return -1 // TAKE NO ACTION ON THIS VALUE, DO NOT EMIT ERROR, LET THE PLAYER CONTINUE
  }
}

export const livePlayerHeartbeatFactory = (hs: HeartbeatService): ListenerDictionary<AuthenticatedStreamResponse> => {
  const heartBeatCancelleationSource: SubjectDictionary = {}
  const cancelHeartbeat = (id: string) => {
    if (heartBeatCancelleationSource[id]) {
      heartBeatCancelleationSource[id].next()
    }
  }

  return {
    play(event, videoElement, videoInstanceId, videoGroupId, hlsLoaderMeta, meta, emitErrorFn) {
      if (!heartBeatCancelleationSource[videoInstanceId]) {
        heartBeatCancelleationSource[videoInstanceId] = new Subject<void>()
      }
      hs.beginTrackingViewTime(hlsLoaderMeta.token.id, heartBeatCancelleationSource[videoInstanceId]).subscribe(
        undefined,
        (err: HeartBeatErrorWrapper | HttpErrorResponse) => {
          // only emit errors for mapped codes greater than -1
          const mappedError = mapServiceErrorsToVideoErrors(err.error.error.statusCode)
          if (mappedError >= 0) {
            emitErrorFn(mappedError, err.error.error.message)
          }
        }
      )
    },
    pause(event, videoElement, videoInstanceId, videoGroupId, hlsLoaderMeta, meta, emitErrorFn) {
      cancelHeartbeat(videoInstanceId)
    },
    ended(event, videoElement, videoInstanceId, videoGroupId, hlsLoaderMeta, meta, emitErrorFn) {
      cancelHeartbeat(videoInstanceId)
    },
    suspend(event, videoElement, videoInstanceId, videoGroupId, hlsLoaderMeta, meta, emitErrorFn) {
      cancelHeartbeat(videoInstanceId)
    }
  }
}
